export default __webpack_public_path__ + "static/soehne-web-buch-kursiv-0ed2a07e824b7dcb18376001999d4eb9.woff2";